var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.966,
    height: 19.966,
    viewBox: "0 0 19.966 19.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-linkedin-3_1_",
    "data-name": "iconmonstr-linkedin-3 (1)",
    d: "M15.806,0H4.16A4.16,4.16,0,0,0,0,4.16V15.806a4.16,4.16,0,0,0,4.16,4.16H15.806a4.16,4.16,0,0,0,4.16-4.16V4.16A4.16,4.16,0,0,0,15.806,0ZM6.655,15.806H4.16V6.655h2.5ZM5.407,5.6A1.468,1.468,0,1,1,6.863,4.133,1.462,1.462,0,0,1,5.407,5.6ZM16.638,15.806h-2.5V11.144c0-2.8-3.328-2.59-3.328,0v4.662h-2.5V6.655h2.5V8.124c1.161-2.151,5.823-2.31,5.823,2.06Z",
    fill: "#d8dfe8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.91fe58a69b849a07963e7f86754c1b13.svg";
export { ForwardRef as ReactComponent };